import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import DoneIcon from '@mui/icons-material/Done';
import Chip from '@mui/material/Chip';
import { green } from '@mui/material/colors';

interface SuccessMessageProps {
  children?: JSX.Element | string;
  onDeleteClick?();
}

const SuccessMessage = ({ onDeleteClick, children }: SuccessMessageProps) => {
  return (
    <Chip
      avatar={
        <Avatar style={{ backgroundColor: green['500'] }}>
          <DoneIcon />
        </Avatar>
      }
      color="primary"
      label={children}
      onDelete={onDeleteClick}
    />
  );
};

export default SuccessMessage;
